export default "__VITE_ASSET__CxCGciIH__"